import { private_server, public_server } from "../../utils/axios"



const usePasswordChange = () => { 

    const actions = {
        onSendEmail: async(data2send) => {
           await public_server.post(`/passwordchange/email`, data2send)
        },
        onSendEmailPin: async(data2send) => {
            await public_server.post(`/passwordchange/email/pin`, data2send)
         },
        onSendMobilePin: async(data2send) => {
            await public_server.post(`/passwordchange/mobile/pin`, data2send)
        },
        onValidate: async(data2send) => {
            await public_server.post(`/passwordchange/validate`, data2send)
        },
        onValidateEmailPin: async(data2send) => {
            await public_server.post(`/passwordchange/validate/email/pin`, data2send)
        },
        onValidateMobilePin: async(data2send) => {
            await public_server.post(`/passwordchange/validate/pin`, data2send)
        },
        onExecute: async(data2send) => {
            await public_server.post(`/passwordchange/execute`, data2send)
        },
        onExecuteWithPin: async(data2send) => {
            await public_server.post(`/passwordchange/execute/pin`, data2send)
        },
        onExecuteEmailPin: async(data2send) => {
            await public_server.post(`/passwordchange/apply/email/pin`, data2send)
        },
    }

    return {
        actions
    }
}
 
export default usePasswordChange;